import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node }, load) => {
  const searchParams = new URLSearchParams(window.location.search);
  const [key, value] = node.dataset.loadUrlParam.split(':');

  if (searchParams.has(key)) {
    if (value && searchParams.get(key) === value) {
      load();
    } else {
      load();
    }
  }

  return () => {};
};

export default Loader;
